import { useId } from 'react';
import { useTranslation } from '@/shared/i18n/use-translation';
import { NativeSelect } from '@/shared/ui/native-select/native-select';
import { NativeSelectOption } from '@/shared/ui/native-select/native-select-option';

type FilterSelectProps<V extends string> = {
  readonly label: string;
  readonly value: V;
  readonly onChange: (value: V) => void;
  /** Labels are English keys, translated here. */
  readonly options: readonly { readonly value: V; readonly label: string }[];
};

/** A native select; its label shows above it inside the phone's filters sheet. */
export function FilterSelect<V extends string>({ label, value, onChange, options }: FilterSelectProps<V>) {
  const { t } = useTranslation();
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="sr-only text-sm font-medium in-data-[slot=filters-sheet]:not-sr-only">
        {label}
      </label>
      <NativeSelect
        id={id}
        value={value}
        // The options are exactly the values of V.
        onChange={(event) => onChange(event.target.value as V)}
        className="in-data-[slot=filters-sheet]:w-full [&_select]:h-10"
      >
        {options.map((option) => (
          <NativeSelectOption key={option.value} value={option.value}>
            {t(option.label)}
          </NativeSelectOption>
        ))}
      </NativeSelect>
    </div>
  );
}
